import type { TFunction } from 'i18next';
import type { TemplateLanguage } from '../../api/hms';

export const MAIN_LANGUAGE = 'nb';

/** The API only gives a name for languages that are not in its list */
export const languageName = (language: TemplateLanguage, t: TFunction) =>
  language.name ?? t(`hms.languages.${language.code}`);

/** «engelsk» in Norwegian sentences, «English» in English ones */
export const languageNameInText = (language: TemplateLanguage, t: TFunction) =>
  language.name ?? t(`hms.languagesInText.${language.code}`);
